import { render, staticRenderFns } from "./OnBoard.vue?vue&type=template&id=3d1194c2"
import script from "./OnBoard.vue?vue&type=script&lang=js"
export * from "./OnBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d1194c2')) {
      api.createRecord('3d1194c2', component.options)
    } else {
      api.reload('3d1194c2', component.options)
    }
    module.hot.accept("./OnBoard.vue?vue&type=template&id=3d1194c2", function () {
      api.rerender('3d1194c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/RecruitProgress/Supervisor/OnBoard.vue"
export default component.exports